import View from "../../../Nav/Js/services/lazyImage";
import components from "./components.js";
components.define("js-LazyImage", View);